export default function Contrato() {
  const fecha = new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="min-h-screen bg-[#0d0520] text-white px-5 py-8 max-w-2xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <button onClick={() => window.history.back()} className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
          <i className="ri-arrow-left-s-line text-xl" />
        </button>
        <h1 className="text-lg font-bold">Contrato de Membresía</h1>
      </div>

      <div className="bg-white/5 rounded-2xl p-5 space-y-5 text-sm leading-relaxed text-gray-200">

        <div>
          <p className="text-xs text-gray-400 mb-1">COVERLY S.A.S. DE C.V. · Culiacán, Sinaloa, México</p>
          <p className="text-xs text-gray-400">Versión 1.0 · Vigente a partir de 2025</p>
        </div>

        <section>
          <h2 className="text-white font-bold text-base mb-2">CONTRATO DE MEMBRESÍA DE PREVISIÓN FUNERARIA FAMILIAR</h2>
          <p>
            El presente contrato se celebra entre <strong className="text-white">COVERLY S.A.S. DE C.V.</strong> (en adelante "COVERLY" o "la Empresa"),
            con domicilio en Culiacán, Sinaloa, México, y el suscriptor identificado en el proceso de registro
            (en adelante "el Miembro"), de conformidad con las siguientes cláusulas:
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">CLÁUSULA I — OBJETO DEL CONTRATO</h2>
          <p>
            COVERLY se obliga a proporcionar al Miembro acceso a una red de servicios funerarios en Culiacán, Sinaloa,
            mediante el pago de una membresía mensual. Los servicios incluyen coordinación funeraria, asesoría 24/7
            vía WhatsApp y teléfono, y gestión de traslados dentro del área metropolitana de Culiacán,
            de acuerdo con el plan contratado.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">CLÁUSULA II — PLANES Y COBERTURA</h2>
          <p className="mb-2">COVERLY ofrece dos planes de membresía:</p>
          <ul className="space-y-2 pl-3">
            <li><strong className="text-white">Plan Básico (3 personas):</strong> $289 MXN mensuales. Cubre al titular más 2 beneficiarios registrados.</li>
            <li><strong className="text-white">Plan Prime (4 personas):</strong> $399 MXN mensuales. Cubre al titular más 3 beneficiarios registrados.</li>
          </ul>
          <p className="mt-2">
            La cobertura aplica únicamente a los beneficiarios registrados al momento de la contratación.
            El Miembro puede actualizar beneficiarios con 30 días de anticipación mediante solicitud escrita.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">CLÁUSULA III — SERVICIOS INCLUIDOS</h2>
          <p className="mb-2">La membresía activa incluye:</p>
          <ul className="space-y-1 pl-3 list-disc list-inside">
            <li>Asesoría y coordinación funeraria personalizada 24/7</li>
            <li>Gestión de trámites ante el Registro Civil</li>
            <li>Coordinación con funeraria afiliada en Culiacán</li>
            <li>Traslado local dentro del área metropolitana de Culiacán</li>
            <li>Acompañamiento y apoyo emocional a la familia</li>
          </ul>
          <p className="mt-2 text-yellow-300 text-xs">
            ⚠️ Los servicios funerarios son prestados por funerarias aliadas independientes. COVERLY actúa como intermediario coordinador.
            Los costos de servicios adicionales (ataúd premium, velatorio, cremación, traslados foráneos) son responsabilidad del Miembro.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">CLÁUSULA IV — VIGENCIA Y ACTIVACIÓN</h2>
          <p>
            La membresía entra en vigor a partir del primer pago mensual confirmado y permanece activa
            mientras el Miembro mantenga sus pagos al corriente. La membresía se renueva automáticamente
            cada mes. En caso de falta de pago por más de 30 días, la cobertura queda suspendida sin
            responsabilidad para COVERLY.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">CLÁUSULA V — CANCELACIÓN</h2>
          <p>
            El Miembro puede cancelar su membresía en cualquier momento mediante notificación al WhatsApp
            oficial de COVERLY (667-568-0042) o correo electrónico. La cancelación surte efecto al término
            del periodo mensual pagado. No se realizan reembolsos de mensualidades ya abonadas.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">CLÁUSULA VI — OBLIGACIONES DEL MIEMBRO</h2>
          <ul className="space-y-1 pl-3 list-disc list-inside">
            <li>Proporcionar información veraz y actualizada al registrarse.</li>
            <li>Mantener sus pagos mensuales al corriente.</li>
            <li>Notificar cambios en beneficiarios con 30 días de anticipación.</li>
            <li>Contactar a COVERLY antes de contratar cualquier servicio funerario externo.</li>
            <li>No ceder ni transferir la membresía a terceros.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">CLÁUSULA VII — LIMITACIONES DE RESPONSABILIDAD</h2>
          <p>
            COVERLY no será responsable por daños indirectos, incidentales o consecuentes derivados del
            uso del servicio. La responsabilidad máxima de COVERLY ante el Miembro se limita al monto
            pagado en el mes en curso. COVERLY no garantiza disponibilidad inmediata de servicios en
            situaciones de fuerza mayor, desastres naturales o contingencias extraordinarias.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">CLÁUSULA VIII — PROTECCIÓN DE DATOS</h2>
          <p>
            COVERLY tratará los datos personales del Miembro conforme a la{' '}
            <strong className="text-white">Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP)</strong>.
            Los datos se usarán exclusivamente para la prestación del servicio y nunca serán vendidos a terceros.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">CLÁUSULA IX — JURISDICCIÓN</h2>
          <p>
            Para la interpretación y cumplimiento del presente contrato, las partes se someten expresamente
            a las leyes vigentes del <strong className="text-white">Estado de Sinaloa, México</strong>, y a la
            jurisdicción de los tribunales competentes de la ciudad de Culiacán, Sinaloa, renunciando a
            cualquier otro fuero que pudiera corresponderles.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">CLÁUSULA X — MODIFICACIONES</h2>
          <p>
            COVERLY se reserva el derecho de modificar los términos del presente contrato con 30 días
            de anticipación mediante notificación al Miembro por los canales registrados. El uso continuo
            del servicio después de dicha notificación implica la aceptación de los cambios.
          </p>
        </section>

        <div className="border-t border-white/10 pt-4 text-xs text-gray-400">
          <p>Al registrarse en la plataforma Coverly y aceptar este contrato electrónicamente, el Miembro declara
          haber leído, entendido y aceptado todas las cláusulas del presente instrumento, el cual tiene plena
          validez legal conforme al Código de Comercio y la Ley Federal de Protección al Consumidor vigentes en México.</p>
          <p className="mt-2">COVERLY S.A.S. DE C.V. · Culiacán, Sinaloa · contacto@coverly.com.mx · 667-568-0042</p>
        </div>

      </div>
    </div>
  );
}
